import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import PricingIcon from "../../../assets/images/feature/Pricing.png";
import QualityIcon from "../../../assets/images/feature/Quality.png";
import CheckMarkIcon from "../../../assets/images/feature/Check-mark.png";
import SupportIcon from "../../../assets/images/feature/Support.png";
import shapebg from "../../../assets/images/feature/feture-bg-shape.png";
import { motion } from "framer-motion";

const Feature = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);
  const [fooder, setfooder] = useState("");

  useEffect(() => {
    fetchCMSData();
    footerdata();
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data); // Save entire list
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };
  // Filter items by type
  const aboutUsItems = cmsData.filter((item) => item.type === "cms");
  return (
    <>
      {fooder.cmspermission == 1 ? (
        <section className="py-60">
          <Container>
            <Row className="row-gap-4">
              {aboutUsItems.map((item, index) => (
                <Col xl={3} sm={6}>
                  <motion.div
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                  >
                    <div className="feature__card mb-24 mb-xl-0">
                      <div className="feature__icon">
                        <img
                          src={
                            item?.image
                              ? `${imagePath}${item.image}`
                              : PricingIcon
                          }
                          alt="features"
                          className="feature-bg-shape"
                        />
                      </div>
                      <div className="feature__content">
                        <h5 className="mb-8">{item.name}</h5>
                        <p
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></p>
                        <img
                          src={shapebg}
                          alt=""
                          className="feature-bg-shape"
                        />
                      </div>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default Feature;
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Col, Container, Row } from "react-bootstrap";
// import { motion } from "framer-motion";
//  import PricingIcon from "../../../assets/images/feature/Pricing.png";

// const Feature = () => {
//   const [cmsData, setCmsData] = useState([]);
//   const [status, setStatus] = useState(null);

//   useEffect(() => {
//     fetchCMSData();
//   }, []);

//   const fetchCMSData = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
//       setCmsData(res.data.data); // Save entire list
//       setStatus(res.data.status);
//     } catch (error) {
//       console.error("Error fetching CMS data", error);
//     }
//   };

//   // Filter items by type
//   const aboutUsItems = cmsData.filter((item) => item.type === "cms");

//   return (
//     <section className="py-60">
//       <Container>
//         <Row className="row-gap-4">
//           {aboutUsItems.map((item, index) => (
//             <Col key={item.id} xl={3} sm={6}>
//               <motion.div
//                 initial={{ opacity: 0, x: 100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 1, delay: 0.5 }}
//               >
//                 <div className="feature__card mb-24 mb-xl-0">
//                   <div className="feature__content">
//                     <div className="feature__icon">
//                       <img
//                         src={PricingIcon}
//                         alt="features"
//                         className="feature-bg-shape"
//                       />
//                     </div>
//                     <h5 className="mb-8">{item.name}</h5>
//                     <div
//                       dangerouslySetInnerHTML={{ __html: item.description }}
//                     />
//                   </div>
//                 </div>
//               </motion.div>
//             </Col>
//           ))}
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default Feature;
